import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import es from './es.json';
import tr from './tr.json';

// Language is chosen by the viewer or a URL parameter, never by geolocation (FPR Art. 11b(4), PRD §4.7). Operator
// screens remember the choice in this browser; the public passport stores nothing.
export const LANGUAGES = ['en', 'es', 'tr'] as const;
const PREF_KEY = 'w2g.lang';

function initialLanguage(): string {
  const fromUrl = new URLSearchParams(window.location.search).get('lang');
  if (fromUrl && (LANGUAGES as readonly string[]).includes(fromUrl)) return fromUrl;
  if (window.location.pathname.startsWith('/p/')) return 'en';
  try {
    return window.localStorage.getItem(PREF_KEY) ?? 'en';
  } catch {
    return 'en';
  }
}

export function rememberLanguage(lang: string): void {
  void i18n.changeLanguage(lang);
  if (window.location.pathname.startsWith('/p/')) return;
  try {
    window.localStorage.setItem(PREF_KEY, lang);
  } catch {
    /* storage unavailable */
  }
}

/** Readable fallback for engine message keys without a translation: 'cmc2.cyanobacteria_excluded' -> words. */
export function humanKey(key: string): string {
  const last = key.includes(':') ? key : (key.split('.').pop() ?? key);
  return last.replace(/[_.]/g, ' ');
}

void i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, es: { translation: es }, tr: { translation: tr } },
  lng: initialLanguage(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

// The page language follows the chosen language, for screen readers and hyphenation (index.html starts as 'en').
const setDocumentLang = (lang: string) => document.documentElement.setAttribute('lang', lang);
setDocumentLang(i18n.language);
i18n.on('languageChanged', setDocumentLang);

export default i18n;
